import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CrossCircleIconXs } from '@lichtblick/icons/svg/cross-circle/cross-circle-xs';
import { SearchIconXs } from '@lichtblick/icons/svg/search/search-xs';
import { forwardRef, useRef } from 'react';
import { FieldFooter } from '../FieldFooter/FieldFooter';
import { Label } from '../Label/Label';
import { doesValueMatchSearch } from './ComboBoxInput.helpers';
import { IconWrapper, Input, InputRow, LabelWrapper, Slot, Wrapper } from './ComboBoxInput.styles';
export const ComboBoxInput = /*#__PURE__*/ forwardRef(({ className, 'data-testid': testId, icon, id, isDisabled, label, name, onChange, options, statusLabel, statusType, value, ...props }, ref)=>{
    const inputRef = useRef(null);
    const dropdownRef = useRef(null);
    const inputId = id || name;
    const labelId = inputId && `${inputId}_label`;
    const statusId = inputId && `${inputId}_validationMessage`;
    const searchValue = value?.toString();
    const filteredOptions = options.filter(({ keywords, value })=>doesValueMatchSearch(value, searchValue) || keywords && doesValueMatchSearch(keywords.join(), searchValue));
    const setValue = (event)=>{
        dropdownRef.current?.open();
        onChange?.(event);
    };
    const focusInput = ()=>inputRef.current?.focus();
    const dispatchChange = (value)=>{
        onChange?.({
            target: {
                value,
                name
            }
        });
        dropdownRef.current?.close();
    };
    const openDropdown = ()=>{
        focusInput();
        dropdownRef.current?.open();
    };
    const clearInput = ()=>dispatchChange('');
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ _jsx(LabelWrapper, {
                children: Boolean(label) && /*#__PURE__*/ _jsx(Label, {
                    htmlFor: inputId,
                    id: labelId,
                    isBold: true,
                    children: label
                })
            }),
            /*#__PURE__*/ _jsxs(InputRow, {
                $isDisabled: isDisabled,
                $statusType: statusType,
                onClose: focusInput,
                onOptionSelect: dispatchChange,
                options: filteredOptions,
                ref: dropdownRef,
                children: [
                    /*#__PURE__*/ _jsx(Input, {
                        ...props,
                        "aria-describedby": statusId,
                        "aria-invalid": statusType === 'error',
                        "aria-labelledby": labelId,
                        "data-testid": testId || inputId,
                        disabled: isDisabled,
                        id: inputId,
                        name: name,
                        onChange: setValue,
                        ref: (instance)=>{
                            if (typeof ref === 'function') {
                                ref(instance);
                            } else if (ref) {
                                ref.current = instance;
                            }
                            inputRef.current = instance;
                        },
                        value: value
                    }),
                    !isDisabled && /*#__PURE__*/ _jsxs(Slot, {
                        children: [
                            Boolean(value) && /*#__PURE__*/ _jsx(IconWrapper, {
                                onClick: clearInput,
                                children: /*#__PURE__*/ _jsx(CrossCircleIconXs, {})
                            }),
                            /*#__PURE__*/ _jsx(IconWrapper, {
                                onClick: openDropdown,
                                children: /*#__PURE__*/ _jsx(SearchIconXs, {})
                            })
                        ]
                    })
                ]
            }),
            Boolean(statusLabel) && /*#__PURE__*/ _jsx(FieldFooter, {
                fieldFooterLabel: statusLabel,
                fieldFooterType: statusType,
                icon: icon,
                id: statusId
            })
        ]
    });
});

//# sourceMappingURL=ComboBoxInput.js.map